var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18.005,
  height: 10.689,
  viewBox: "0 0 18.005 10.689"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.272 -106.412)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 106.662)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.4,111.55c-.138-.2-3.443-4.888-8.668-4.888-4.484,0-8.479,4.661-8.647,4.859a.365.365,0,0,0,0,.47c.168.2,4.164,4.859,8.647,4.859s8.479-4.661,8.647-4.859A.364.364,0,0,0,17.4,111.55Zm-8.668,4.573c-3.594,0-7.012-3.428-7.88-4.367.867-.94,4.281-4.367,7.88-4.367,4.206,0,7.174,3.423,7.9,4.347C15.8,112.646,12.358,116.123,8.733,116.123Z",
  transform: "translate(0 -106.662)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.822 108.845)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M173.573,170.662a2.911,2.911,0,1,0,2.911,2.911A2.914,2.914,0,0,0,173.573,170.662Zm0,5.094a2.183,2.183,0,1,1,2.183-2.183A2.186,2.186,0,0,1,173.573,175.756Z",
  transform: "translate(-170.662 -170.662)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}))))));
export default __webpack_public_path__ + "static/media/eye.6e962950.svg";
export { SvgComponent as ReactComponent };